<script lang="ts">
	import Line from './Line.svelte'
	import { _ } from '@repo/i18n'
	import type { Snippet } from 'svelte'

	interface Props {
		children?: Snippet
	}

	let { children }: Props = $props()
</script>

<div class="flex items-center">
	<div class="flex flex-1"><div class="w-full"><Line /></div></div>
	<div class="mx-10 flex text-gray-400 uppercase">
		{#if children}{@render children()}{:else}
			{$_('signUpForm.or')}
		{/if}
	</div>
	<div class="flex flex-1"><div class="w-full"><Line /></div></div>
</div>
